import React from 'react';
import { LEAN_BLOCKS } from './constants';

import { Rect, Group, Text } from 'react-konva';
import { injectIntl } from 'react-intl';
import { inject, observer } from 'mobx-react';
import { isLeanBlock } from './functions';

@injectIntl
@inject('rootStore')
@observer
export default class OldArchitectureBlock extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.history.push(this.props.rootStore.blockPath(this.props.block));
  }

  render() {
    const {
      intl,
      x,
      y,
      width,
      height,
      block,
      disabled,
      stepNumber
    } = this.props;
    const currentBlock = this.props.rootStore.igBusinessStore.currentBlock;
    let cards = [];
    let title = '';
    if (
      block == LEAN_BLOCKS.MEASURE ||
      block == LEAN_BLOCKS.LEARN ||
      block == LEAN_BLOCKS.BUILD
    ) {
      cards = this.props.rootStore.activityStore.activityEdit.getLeanBlockElements(
        block
      );
    } else {
      cards = this.props.rootStore.activityStore.activityEdit.getSelectedCardsByBlock(
        block
      );
      title = intl.formatMessage({ id: 'IgbmcBoard-' + block });
    }
    let subtitle = intl.formatMessage({ id: 'subtitle-' + block });

    let cardItems = [];
    const titleHeight = 30;
    const cardHeight = 30;
    const marginBottomTitle = 10;

    let maxCards = (height - (titleHeight + marginBottomTitle)) / cardHeight;
    let fillColor = 'white';
    let strokeColor = '#ddd';
    let strokeWidth = 1;
    let headerFillColor = '#ddd';
    let headerTextColor = '#555';

    if (cards.length > 0) {
      fillColor = 'white';
      strokeColor = '#6883A4';
      headerFillColor = '#6883A4';
      headerTextColor = 'white';
    }
    if (block == currentBlock) {
      strokeColor = '#0fa69a';
      strokeWidth = 4;
      headerFillColor = '#0fa69a';
      headerTextColor = 'white';
    }
    if (isLeanBlock(block)) {
      if (cards.length > 0) {
        strokeColor = '#7872AE';
        headerFillColor = '#7872AE';
      }
      if (block == currentBlock) {
        strokeColor = '#A5A0CD';
        headerFillColor = '#A5A0CD';
      }
    }
    if (disabled) {
      strokeColor = '#efefef';
      headerFillColor = '#efefef';
      headerTextColor = '#777';
    }

    for (let i = 0; i < cards.length && i + 1 < maxCards; i++) {
      cardItems.push(
        <Group>
          <Rect
            x={x + 10}
            y={y + marginBottomTitle + cardHeight * (i + 1)}
            width={width - 20}
            height={25}
            fill="white"
            stroke="#ccc"
            strokeWidth={1}
            cornerRadius={2}
          />
          <Text
            x={x + 15}
            y={y + marginBottomTitle + cardHeight * (i + 1) + 5}
            width={width - 30}
            align="left"
            text={cards[i].description || cards[i].name || cards[i]}
            fontSize={14}
            lineHeight={1.3}
            fontFamily="Helvetica"
            fill="#333"
            wrap="none"
          />
        </Group>
      );
    }
    if (cards.length >= maxCards) {
      cardItems.push(
        <Text
          x={x + 10}
          y={y + height - 23}
          width={width - 20}
          align="center"
          text="..."
          fontSize={18}
          fontFamily="Helvetica"
          fill="#777"
        />
      );
    }
    return (
      <Group onClick={this.handleClick}>
        <Rect
          x={x}
          y={y}
          width={width}
          height={height}
          fill={'white'}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          cornerRadius={6}
        />
        <Rect
          x={x}
          y={y}
          width={width}
          height={40}
          fill={headerFillColor}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          cornerRadius={1}
        />
        <Text
          x={x + 10}
          y={y + 5}
          width={width - 20}
          height={titleHeight}
          align="left"
          text={stepNumber + '. ' + subtitle.toUpperCase()}
          fontSize={11}
          fontFamily="Helvetica"
          fill={headerTextColor}
          fontStyle="bold"
        />
        <Text
          ref={'title'}
          x={x + 10}
          y={y + 10 + 12}
          width={width - 20}
          height={titleHeight}
          align="left"
          text={title}
          fontSize={12}
          fontFamily="Helvetica"
          fill={headerTextColor}
          fontStyle="bold"
        />
        <Group y={5}>
          {cardItems.map((el, id) => (
            <Group key={id}>{el}</Group>
          ))}
        </Group>
      </Group>
    );
  }

  renderCardItemsOrPlaceholder(
    cardItems,
    x,
    y,
    marginBottomTitle,
    cardHeight,
    width,
    titleHeight
  ) {
    let placeholder = 'Add an item';
    if (cardItems.length > 0) {
      return (
        <Group y={5}>
          {cardItems.map((el, id) => (
            <Group key={id}>{el}</Group>
          ))}
        </Group>
      );
    } else {
      return (
        <Text
          ref={'title'}
          x={x + 15}
          y={y + marginBottomTitle + 2 * cardHeight - 5}
          width={width - 30}
          height={titleHeight}
          align="center"
          text={placeholder}
          fontSize={14}
          fontFamily="Helvetica"
          fill="#aaa"
        />
      );
    }
  }
}
